// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__6dPX9","row":"Node_row__FcWVF","label":"Node_label__16Vmv","footer":"Node_footer__2YhQb"};